// Fixed "motivo" values for including, in one roll call, a student who
// isn't enrolled in the class (recuperação/aula teste) — mirrors
// amsm-backend's `activities.enums.AttendanceInclusionReason`. Shared by the
// roll call screen (`gym/ActivityClassRollCall`, where it's picked) and the
// frequency ranking report (`attendance/AttendanceReport`, where it's shown).
export const AD_HOC_REASON_OPTIONS = [
  { value: 'makeup_class', label: 'Recuperação' },
  { value: 'trial_class', label: 'Aula teste' },
]

export const AD_HOC_REASON_LABELS = AD_HOC_REASON_OPTIONS.reduce(
  (labels, option) => ({ ...labels, [option.value]: option.label }),
  {}
)
